import { useState, useEffect, useMemo, useCallback, ChangeEvent, FC } from 'react';
import { TextField, Button, Typography } from '@material-ui/core';
import { ArrowRightAverageIcon } from '@images/icons';
import { translate } from '@utils';

interface PaginationChangePageProps {
  page: number;
  pages: number;
  handleChangePageNumber: (prop: number) => void;
}

const PaginationChangePage: FC<PaginationChangePageProps> = ({
  handleChangePageNumber,
  pages,
  page,
}) => {
  const [userPage, setUserPage] = useState(page + 1);

  const range = useMemo(() => ({ min: 1, max: pages }), [pages]);

  useEffect(() => setUserPage(page + 1), [page, pages]);

  const handleFieldBlur = useCallback((e) => {
    if (!e.target.value) {
      setUserPage(1);
      handleChangePageNumber(1);
    }
  }, []);

  const handleInputChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      let value;
      if (e.target.value) {
        value = parseInt(e.target.value, 10);
        if (value > range.max) value = range.max;
        if (value < range.min) value = range.min;
      } else {
        value = '';
      }
      setUserPage(value);
    },
    [range]
  );

  return (
    <div className="pagination-page">
      <Typography variant="body2">{`${translate('pagination_change_page')}:`}</Typography>
      <TextField
        className="pagination-page_per-page"
        value={userPage}
        type="number"
        inputProps={range}
        onChange={handleInputChange}
        variant="outlined"
        onBlur={handleFieldBlur}
      />
      <Button
        startIcon={<ArrowRightAverageIcon />}
        onClick={() => handleChangePageNumber(userPage)}
      ></Button>
    </div>
  );
};

export { PaginationChangePage };
